import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Typography,
} from '@mui/material';

const DataTable = ({ Mdata }) => {
  const columns = [
    { id: 'wallet', label: 'Wallet', width: '33.33%' },
    { id: 'children_count', label: 'Ref', width: '33.33%' },
    { id: 'points', label: 'Points', width: '33.33%' },
  ];

  return (
    <TableContainer sx={{ width: '100%' }}>
    <Table sx={{ width: '100%' }}>
    <TableHead style={{width:"100%",display:"table-caption"}}>
      <TableRow sx={{
        display:"flex",
    width: '100%', 
    m: 0,          
    p: 0         
  }}>
    {columns.map((column) => (
      <TableCell 
        key={column.id}
        style={{ 
          width:"33.33%", 
          borderBottom: '2px solid #e0e0e0'
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          {column.label}
        </Typography>
      </TableCell>
    ))}
    </TableRow>
            </TableHead>
            <TableBody>
          {Mdata?.length > 0 ? (
            Mdata.map((row, index) => (
              <TableRow 
                key={index}
                sx={{ '&:last-child td': { borderBottom: 0 } }}
              >
                {columns.map((column) => (
                  <TableCell 
                    key={column.id}
                    sx={{ 
                      width: column.width,
                      borderBottom: '1px solid #e0e0e0'
                    }}
                  >
                    <Typography variant="body2">
                      {row[column.id] || '-'}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body2" color="text.secondary">
                  No data available
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
    
    </Table>
    </TableContainer>
  );
};

export default DataTable;